export default __webpack_public_path__ + "static/media/JobFive3.abc06e6a.jpg";